module.exports = __webpack_public_path__ + "_/img/bag.a2751ec7.jpg";